import styled, { css } from 'styled-components';
import { Typography } from '../../../global/theme';
import { mobile_xl } from '../../../global/mediaQueryMixin';
import { AlignCenter, FlexCenter } from '../../../global/commonStyle';

const Group = styled.div`
  width: 100%;
  height: 100vh;
  background-color: var(--background-secondary);
  margin-inline: auto;
  overflow: auto;
  ${FlexCenter}
  ${mobile_xl(css`
    min-height: unset;
    align-items: flex-start;
    height: 100dvh;
  `)}
`;

const Content = styled.form`
  width: 100%;
  max-width: 480px;
  ${AlignCenter}
  flex-direction: column;
  background-color: var(--background-secondary);
  gap: var(--space-20);
  ${mobile_xl(css`
    gap: var(--space-32);
    max-width: -webkit-fill-available;
    padding: var(--space-32) var(--space-24);
    margin: auto var(--space-0);
  `)}
`;

const Icon = styled.div`
  ${AlignCenter}
  cursor: pointer;
  ${mobile_xl(css`
    height: 40px;
    .svgIcon {
      width: 40px;
      height: 40px;
    }
  `)}
`;

const Title = styled.h1`
  ${Typography.heading_lg}
  color: var(--text-primary);
  margin: var(--space-0);
  ${mobile_xl(css`
    text-align: center;
  `)}
`;

const FormBlock = styled.div`
  display: flex;
  flex-direction: column;
  gap: var(--space-20);
  border-radius: var(--border-radius-8);
  border: 0.5px solid var(--border-primary);
  background: var(--text-white);
  box-shadow: var(--shadow-card-hover);
  padding: var(--space-20);
  ${mobile_xl(css`
    padding: var(--space-18);
    gap: var(--space-32);
  `)}
`;

const Text = styled.p`
  ${Typography.body_md}
  color: var(--text-secondary);
  margin: var(--space-0);
  ${mobile_xl(css`
    text-align: center;
  `)}
`;

const SubBlock = styled.div`
  display: flex;
  flex-direction: column;
  gap: var(--space-16);
  ${mobile_xl(css`
    gap: var(--space-20);
  `)}
`;

const Item = styled.div`
  display: flex;
  flex-direction: column;
  gap: var(--space-8);
  input[type='password']:not(:placeholder-shown) {
    color: var(--text-secondary);
  }
  .password:not(:placeholder-shown) {
    height: 20px;
  }
  ${mobile_xl(css`
    .password:not(:placeholder-shown) {
      height: 22px;
    }
  `)}
`;

const Label = styled.label`
  ${Typography.body_md_medium}
  color: var(--text-secondary);
`;

const InputValue = styled.input`
  ${Typography.body_lg_medium}
  background-color: var(--text-white);
  color: var(--text-primary);
  border: 0.5px solid var(--border-primary);
  padding: var(--space-8) var(--space-12);
  border-radius: var(--border-radius-6);
  outline: none;

  ${(props: { disabled?: boolean }) =>
    props.disabled &&
    css`
      background-color: var(--background-secondary);
      border: 0.5px solid var(--border-primary);
      color: var(--text-muted);
    `}

  &:focus {
    border: 0.5px solid var(--brand-primary);
  }
  ::placeholder {
    ${Typography.body_lg_medium}
    color: var(--text-secondary);
  }
  ${mobile_xl(css`
    padding: var(--space-12);
  `)}
`;

const FormContent = styled.div`
  width: 100%;
  max-width: 480px;
  display: flex;
  flex-direction: column;
  gap: var(--space-20);
  .joinButton {
    margin-left: auto;
  }
  ${mobile_xl(css`
    gap: var(--space-24);
    .joinButton {
      margin: var(--space-0);
      display: contents;
    }
  `)}
`;

const ProfileView = styled.div`
  padding-top: var(--space-16);
  text-align: center;
`;
const Box = styled.div`
  max-width: 338px;
  width: 100%;
  border-radius: var(--border-radius-12);
  border: 0.5px solid var(--border-primary);
  background-color: var(--text-white);
  padding: var(--space-20);
  ${AlignCenter}
  flex-direction: column;
  gap: var(--space-16);
  box-shadow: var(--shadow-card);
`;
const LinkIcon = styled.div`
  width: 56px;
  height: 56px;
  background-color: var(--neutral-secondary);
  border-radius: var(--border-radius-full);
  ${FlexCenter}
`;
const LinkContent = styled.div`
  ${AlignCenter}
  flex-direction: column;
  gap: var(--space-8);
  p {
    margin: var(--space-0);
    ${Typography.body_md}
    color: var(--text-secondary);
    text-align: center;
  }
  h2 {
    margin: var(--space-0);
    ${Typography.heading_md}
    color: var(--text-primary);
  }
`;
export {
  Content,
  FormContent,
  FormBlock,
  Group,
  Icon,
  InputValue,
  Item,
  Label,
  ProfileView,
  SubBlock,
  Text,
  Title,
  Box,
  LinkIcon,
  LinkContent
};
